// The public third party claims in static text files (sitemap.xml, llms.txt, llms-full.txt) sit
// between two marker lines. While THIRD_PARTY_PUBLIC (src/lib/third-party.ts) is false the build
// removes the whole block; when it is true the build removes only the marker lines.
//
// Plain .mjs so the build script (Node) and the app (Vite) share one implementation.
export const THIRD_PARTY_BEGIN = '<!-- third-party:begin -->'
export const THIRD_PARTY_END = '<!-- third-party:end -->'

/**
 * @param {string} text
 * @param {boolean} on  the value of THIRD_PARTY_PUBLIC
 * @returns {string}
 */
export function applyThirdPartyGate(text, on) {
  const out = []
  let inside = false
  for (const line of text.split('\n')) {
    const mark = line.trim()
    if (mark === THIRD_PARTY_BEGIN) {
      if (inside) throw new Error('unbalanced third-party markers: nested begin')
      inside = true
    } else if (mark === THIRD_PARTY_END) {
      if (!inside) throw new Error('unbalanced third-party markers: end without begin')
      inside = false
    } else if (on || !inside) {
      out.push(line)
    }
  }
  if (inside) throw new Error('unbalanced third-party markers: begin without end')
  return out.join('\n')
}
